
import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BaseSelector } from "./BaseSelector";
import { AssignedBasesList } from "./AssignedBasesList";
import { useBaseAssignments } from "./hooks/useBaseAssignments";

type UserRole = 'admin' | 'user' | 'atc' | 'dm' | 'sales_assistant';

interface RoleBaseAssignmentsProps {
  selectedRole: UserRole | '';
}

export const RoleBaseAssignments = ({ selectedRole }: RoleBaseAssignmentsProps) => {
  const {
    bases,
    assignedBases,
    selectedBase,
    setSelectedBase,
    loading,
    saving,
    assignBaseToRole,
    removeBaseAssignment
  } = useBaseAssignments(selectedRole);

  // Special check for admin role
  const isAdminRole = selectedRole === 'admin';

  if (!selectedRole) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Role Base Assignments</CardTitle>
          <CardDescription>
            Select a role above to manage its base assignments
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Base Assignments for {selectedRole}</CardTitle>
        <CardDescription>
          {isAdminRole 
            ? "Admin users automatically have access to all bases"
            : "Assign bases that users with this role can access"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isAdminRole ? (
          <div className="bg-green-50 p-4 rounded-md border border-green-200">
            <p className="text-green-800">
              Admin users have automatic access to all bases. No specific assignments needed.
            </p>
          </div>
        ) : (
          <>
            <BaseSelector
              bases={bases}
              selectedBase={selectedBase}
              onBaseChange={setSelectedBase}
              onAssignBase={assignBaseToRole}
              saving={saving}
            />

            <AssignedBasesList
              loading={loading}
              assignedBases={assignedBases}
              onRemoveBase={removeBaseAssignment}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
